//
//  Section.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import React from "react";
import Box from "@mui/material/Box";

type SectionContainerProps = {
  children: React.ReactNode;
  width?: string;
};

export const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
}) => (
  <Box display="flex" flexDirection="column" gap={4} mt={2} width="fit-content">
    {children}
  </Box>
);

type SectionRowProps = {
  title: string;
  children: React.ReactNode;
  alignItems?: "center" | "start" | "end";
  direction?: "row" | "column"; 
};

export const SectionRow: React.FC<SectionRowProps> = ({
  title,
  children,
  alignItems = "start", 
  direction = "column",  
}) => (
  <Box 
    display="flex" 
    flexDirection={direction} 
    alignItems={alignItems} 
    gap={1}
    width="100%"
  >
    <Box 
      fontWeight="bold" 
      fontSize={16}
      sx={{ mb: direction === "column" ? 0.5 : 0 }} 
    >
      {title}
    </Box>
    {children}
  </Box>
);